/** @format */

import {LastCheckType, SensorGroupsType} from '../../../types';
import {CampaignSensor, SensorSeverity} from '..';
import {getPerCampaignFound} from '../../../helpers/getPerCampaignFound';

const getSensorSeverity = (sensorName: string, sensorGroups: SensorGroupsType): SensorSeverity => {
  if (sensorGroups.red.includes(sensorName)) return 'red';
  if (sensorGroups.yellow.includes(sensorName)) return 'yellow';
  if (sensorGroups.gray.includes(sensorName)) return 'gray';
  return 'gray';
};

export const mapLastChecksToCards = (
  lastChecks: ReadonlyArray<LastCheckType>,
  sensorGroups: SensorGroupsType,
): Map<string, CampaignSensor[]> => {
  const campaignSensorsMap = new Map<string, CampaignSensor[]>();

  lastChecks.forEach(check => {
    if (!check.campaignIds || check.campaignIds.length === 0) {
      return;
    }

    const severity = getSensorSeverity(check.sensor.name, sensorGroups);
    const isCritical = severity === 'red';

    check.campaignIds.forEach(campaignId => {
      const perCampaignFound = getPerCampaignFound(check, campaignId);

      if (perCampaignFound === 0) return;

      const sensor: CampaignSensor = {
        id: check.sensor.id,
        name: check.sensor.name,
        count: perCampaignFound,
        isCritical,
        severity,
      };

      const existing = campaignSensorsMap.get(campaignId) || [];
      existing.push(sensor);
      campaignSensorsMap.set(campaignId, existing);
    });
  });

  // Сортируем сенсоры по важности
  campaignSensorsMap.forEach((sensors, campaignId) => {
    const sorted = sensors.sort((a, b) => {
      const severityOrder = {red: 0, yellow: 1, gray: 2};
      const severityDiff = severityOrder[a.severity!] - severityOrder[b.severity!];
      if (severityDiff !== 0) return severityDiff;
      return b.count - a.count;
    });
    campaignSensorsMap.set(campaignId, sorted);
  });

  return campaignSensorsMap;
};
